import Vue from 'vue'
import * as types from '../types'
const version = '1.0'
if (window.store.get('version-m') !== version) {
  window.store.clearAll()
}
// state
const state = {
  userinfo: window.store.get('version-m') === version && window.store.get('userInfo') !== undefined ? JSON.parse(window.store.get('userInfo')) : null,
  slider: window.store.get('version-m') === version && window.store.get('slider') !== undefined ? JSON.parse(window.store.get('slider')) : null,
  setting: window.store.get('version-m') === version && window.store.get('setting') !== undefined ? JSON.parse(window.store.get('setting')) : null
}

const mutations = {
  [types.SIGNIN](state, {
    result,
    index
  }) {
    state.userinfo = result.userInfo
    state.userinfo.pageIndex = index
    Vue.$ga.set({
      userId: state.userinfo.id
    })
    window.store.set('userInfo', JSON.stringify(state.userinfo))
    window.store.set('MERCHANTLOGINED', true, new Date().getTime() + 86400000)
    window.store.set('version-m', version)
  },
  [types.RESIGN](state) {
    state.userinfo = window.store.get('version-m') === version && window.store.get('userInfo') !== undefined ? JSON.parse(window.store.get('userInfo')) : null
    state.slider = window.store.get('version-m') === version && window.store.get('slider') !== undefined ? JSON.parse(window.store.get('slider')) : null
    state.setting = window.store.get('version-m') === version && window.store.get('setting') !== undefined ? JSON.parse(window.store.get('setting')) : null
  },
  [types.SLIDER](state, result) {
    state.slider = result.menu
    state.setting = result.settings
    window.store.set('slider', JSON.stringify(state.slider))
    window.store.set('setting', JSON.stringify(state.setting))
  },
  [types.SIGNOUT](state) {
    state.userinfo = null
    state.slider = null
    state.setting = null
    window.store.clearAll()
  },
  [types.ISSIGN](state) {
    // 签约
    state.userinfo.onBoarding = '3'
    window.store.set('userInfo', JSON.stringify(state.userinfo))
  },
  [types.SETFEE](state) {
    state.userinfo.onBoarding = '4'
    window.store.set('userInfo', JSON.stringify(state.userinfo))
  },
  [types.AGREECOUPON](state) {
    state.userinfo.agreeCoupon = '1'
    window.store.set('userInfo', JSON.stringify(state.userinfo))
  },
  [types.CHANGELANG](state, lang) {
    state.userinfo.lang = lang
    window.store.set('userInfo', JSON.stringify(state.userinfo))
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js